
import { Component } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { getTableName } from '@/worker/db/sqlHelpers';
import moment from 'moment';
import gdbx from '@/store/modules/gdbx';

@Component({
	components: {
		AmountDisplayerFilterable,
	},
})
export default class BpCogsNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['transactions'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
    | 'project'
	> = ['dateAsOf'];

	public amount: number = 0;

	public get accountStartingPeriodThisYear(): [number, number] {
		return [gdbx.accountStartingDateThisYear, moment().endOf('day').valueOf()];
	}

	public get expensiveHook() {
		const {
			selectedAsOfDate,
			selectedDateRange,
			accountStartingPeriodThisYear,
      selectedProjects,
		} = this;
		return JSON.stringify([
			selectedAsOfDate,
			selectedDateRange,
			accountStartingPeriodThisYear,
      selectedProjects,
		]);
	}

    public openingStockDateRange(dateRange: [number, number]): [number, number] {
        return [
            moment(dateRange[0]).add(-1, 'month').valueOf(),
            moment(dateRange[1]).add(-1, 'month').valueOf(),
        ];
    }

	public async expensiveCalc() {
		const escapeStr = (s: string) => s.replace(/'/g, '\'\'');
		const txnTable = getTableName('transactions');
		const stockTable = getTableName('stockBalances');
		const range = this.selectedDateRange;
		const openingRange = this.openingStockDateRange(range);

		let projectFilter = '';
		if (this.selectedProjects.length > 0) {
			const list = this.selectedProjects.map((p) => `'${escapeStr(p)}'`).join(',');
			projectFilter = ` AND "PROJECT" IN (${list})`;
		}

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['transactions', 'stockBalances']);
		this.checkInterrupted(jobId);

		this.generateLoadingText(0.3);

		const [costResult, openingResult, closingResult] = await Promise.all([
			queryHead.rawQuery(`
				SELECT SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
				FROM ${txnTable}
				WHERE TRY_CAST("DOCDATE" AS BIGINT) BETWEEN ${range[0]} AND ${range[1]}
					AND "ACCTYPE" = 'CO'
					${projectFilter}
			`),
			queryHead.rawQuery(`
				SELECT SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
				FROM ${stockTable}
				WHERE TRY_CAST("DOCDATE" AS BIGINT) BETWEEN ${openingRange[0]} AND ${openingRange[1]}
					${projectFilter}
			`),
			queryHead.rawQuery(`
				SELECT SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
				FROM ${stockTable}
				WHERE TRY_CAST("DOCDATE" AS BIGINT) BETWEEN ${range[0]} AND ${range[1]}
					${projectFilter}
			`),
		]);
		this.checkInterrupted(jobId);

		const costTotal = Number(costResult[0] && costResult[0].total) || 0;
		const openingStockTotal = Number(openingResult[0] && openingResult[0].total) || 0;
		const closingStockTotal = Number(closingResult[0] && closingResult[0].total) || 0;

		this.amount = costTotal + openingStockTotal - closingStockTotal;

		this.saveHistory('amount');
	}
}
